const AllErrors = {
   0: "program",
   1: "runTime",
   2: "yarnLength",
   3: "tensionMax",
   4: "tensionMin",
   5: "capstanWraps",
   6: "stdEfficiency",
   7: "stdSpindleCount",
   8: "applicatorRollRPM",
   9: "begBackPressureMax",
   10: "begBackPressureMin",
   11: "begTensionMax",
   12: "begTensionMin",
   13: "clockSetting",
   14: "endBackPressureMax",
   15: "endBackPressureMin",
   16: "gearA",
   17: "gearB",
   18: "numFields",
   19: "speedSetting",
   20: "springPlate",
   21: "springPosBottom",
   22: "springPosTop",
   23: "tensionSpeedArm",
   24: "creelTensionMin",
   25: "creelTensionMax",
   26: "spindleSpeed",
   27: "windingTensionMin",
   28: "windingTensionMax",
   29: "impulseSet",
   30: "backPressureSpring",
   31: "feederTensionSet",
   32: "feederWraps",
   33: "layWheelSet",
   34: "lubeRollerMax",
   35: "lubeRollerStart",
   36: "speed",
   37: "tensionEnd",
   38: "tensionPostSet",
   39: "tensionStart",
   40: "threadBreakTimeout",
   41: "threadGuide",
   42: "timeConveyor",
   43: "timeDeposit",
   44: "underwindD",
   45: "underwindL",
   46: "underwindS",
   47: "yards",
   48: "length",
   49: "girth",
   50: "bottomTrim",
   51: "cycleVariable",
   52: "f1",
   53: "startPos",
   54: "traverseMax",
   55: "traverseMin",
   56: "traverseSpeed",
   57: "trimAmount",
   58: "type",
   59: "acceleration",
   60: "ballSpindle",
   61: "ballTop",
   62: "clockSet",
   63: "counterSet",
   64: "counterSwitch",
   65: "deceleration",
   66: "deckLower",
   67: "deckUpper",
   68: "delayLower",
   69: "delayUpper",
   70: "encoderImpulse",
   71: "fAnti",
   72: "faultWarning",
   73: "firstTwist",
   74: "fMinLower",
   75: "hAnti",
   76: "maxStroke",
   77: "maxStrokeCount",
   78: "maxStrokeCycle",
   79: "minStroke",
   80: "packageType",
   81: "pulseRate",
   82: "ringSpeedUp",
   83: "ringStartPos",
   84: "ringSpeedDown",
   85: "rollerCoefficient",
   86: "rollerDiameter",
   87: "rollerImpulse",
   88: "rotation",
   89: "runReset",
   90: "screwPitch",
   91: "secondTwist",
   92: "speedLower",
   93: "speedMonitoring",
   94: "speedUpper",
   95: "strokeIncrement",
   96: "traveler1",
   97: "traveler2",
   98: "traveler3",
   99: "traveler4",
   100: "traveler5",
   101: "traveler6",
   102: "traveler7",
   103: "traveler8",
   104: "traveler9",
   105: "travelerQty1",
   106: "travelerQty2",
   107: "travelerQty3",
   108: "travelerQty4",
   109: "travelerQty5",
   110: "travelerQty6",
   111: "travelerQty7",
   112: "travelerQty8",
   113: "travelerQty9",
   114: "yarnSpeedMin",
   115: "yarnSpeedMax",
   116: "graf",
   117: "gearC",
   118: "gearD",
   119: "gearE",
   120: "gearF",
   121: "diffCamLink",
   122: "tensionAdj",
   123: "yarnSpeed",
   124: "counterFC71",
   125: "counterFC72",
   126: "waxTemp",
   127: "wiperWeights",
   128: "backPressMax",
   129: "backPressMin",
   130: "scaleFactor",
   131: "gearSpindle",
   132: "gearIntermediate",
   133: "gearInnerGainer",
   134: "gearOuterGainer",
   135: "gearCam",
   136: "bondTemp",
   137: "boxPressure",
   138: "boxSetting",
   139: "boxStretch",
   140: "creelType",
   141: "numberPasses",
   142: "oven1PanelBtm",
   143: "oven1PanelTop",
   144: "oven1TempBtm",
   145: "oven1TempTop",
   146: "oven2PanelBtm",
   147: "oven2PanelTop",
   148: "oven2TempBtm",
   149: "oven2TempTop",
   150: "preFeedPressure",
   151: "preFeedSetting",
   152: "speedFast",
   153: "speedSlow",
   154: "zoneBBarPos",
   155: "zoneBTensionMax",
   156: "zoneBTensionMin",
   157: "zoneCTensionMax",
   158: "zoneCTensionMin",
   159: "wiperWeight",
   160: "linearSet",
   161: "changeGear",
   162: "drivenConstant",
   163: "driverConstant",
   164: "backPressureBegin",
   165: "backPressureEnd",
   166: "degreesEnd",
   167: "degreesStart",
   168: "leftCompensation",
   169: "leftTaper",
   170: "programName",
   171: "rightCompensation",
   172: "rightTaper",
   173: "speedEnd",
   174: "speedMiddle",
   175: "speedStart",
   176: "traverse",
   177: "tubeOD",
   178: "windRatioStart",
   179: "windRatioEnd",
   180: "windType",
   181: "yardsPerPkg",
   182: "metersPerPkg",
   183: "decelSpeed",
   184: "initialSpeed",
   185: "productionSpeed",
   186: "deliverySpeed",
   187: "balloonGuide",
   188: "numEnds",
   189: "potLids",
   190: "spindleWraps",
   191: "supplyTubeColor",
   192: "tensionDevice",
   193: "tensionSet",
   194: "bullet",
   195: "tensionLI",
   196: "tensionLow",
   197: "tensionMid",
   198: "tensionHigh",
   199: "specification",
   200: "spacing",
   201: "underwindB",
   202: "underwindD_DNU", // (duplicate of 44, added "_DNU" to end indicating do not use)
   203: "underwindK",
   204: "underwindT",
   205: "reserveDisk",
   206: "springNum",
   207: "celsius1",
   208: "celsius2",
   209: "celsius3",
   210: "celsiusMin1",
   211: "celsiusMin2",
   212: "celsiusMin3",
   213: "cycleCount",
   214: "mBar1",
   215: "mBar2",
   216: "mBar3",
   217: "minTime1",
   218: "minTime2",
   219: "minTime3",
   220: "pounds",
   221: "burner",
   222: "circulationSpeed",
   223: "exhaust",
   224: "fan",
   225: "highLimit",
   226: "tempControl",
   227: "timer",
   228: "recipe",
   229: "dancerArmTension",
   230: "totalEnds",
};

const DefaultErrors = {
   program: false,            // 0   Doubler, DS10E, Kingspool, Tain35AFP, Tain35AR, 35ATube, TC2, UT50, Xorella
   runTime: false,            // 1   COMMON TO ALL
   yarnLength: false,         // 2   DS10E
   tensionMax: false,         // 3   DS10E, HeliPirn, TexKing
   tensionMin: false,         // 4   DS10E, HeliPirn, TexKing
   capstanWraps: false,       // 5   DS10E, TC2, UT50, XENO
   stdEfficiency: false,      // 6   COMMON TO ALL
   stdSpindleCount: false,    // 7   COMMON TO ALL
   applicatorRollRPM: false,  // 8   861Tack, DS21, Sahm
   begBackPressureMax: false, // 9   861FC, 861Tack, 861Wax, DS21
   begBackPressureMin: false, // 10  861FC, 861Tack, 861Wax, DS21
   begTensionMax: false,      // 11  861FC, 861Tack, DS21
   begTensionMin: false,      // 12  861FC, 861Tack, DS21
   clockSetting: false,       // 13  861Tack, Doubler, DS21, Mahan
   endBackPressureMax: false, // 14  DS21
   endBackPressureMin: false, // 15  DS21
   gearA: false,              // 16  DS21
   gearB: false,              // 17  DS21
   numFields: false,          // 18  DS21
   speedSetting: false,       // 19  DS21
   springPlate: false,        // 20  DS21-[REMOVED]
   springPosBottom: false,    // 21  DS21-[REMOVED]
   springPosTop: false,       // 22  DS21-[REMOVED]
   tensionSpeedArm: false,    // 23  DS21-[REMOVED]
   creelTensionMin: false,    // 24  861Tack, Doubler, Mahan, Ratera, Sahm
   creelTensionMax: false,    // 25  861Tack, Doubler, Mahan, Ratera, Sahm
   spindleSpeed: false,       // 26  Doubler, HeliPirn
   windingTensionMin: false,  // 27  Doubler, DP5, Duro, M50, M50Wax, Ratera, Sahm, Xeno
   windingTensionMax: false,  // 28  Doubler, DP5, Duro, M50, M50Wax, Ratera, Sahm, Xeno
   impulseSet: false,         // 29  Hacoba, TainS41
   backPressureSpring: false, // 30  Hacoba, TainS41
   feederTensionSet: false,   // 31  Hacoba, TainS41
   feederWraps: false,        // 32  Hacoba, TainS41
   layWheelSet: false,        // 33  Hacoba, TainS41
   lubeRollerMax: false,      // 34  Hacoba, TainS41
   lubeRollerStart: false,    // 35  Hacoba, TainS41
   speed: false,              // 36  Hacoba, Saco, Tain35AFP, Tain35AR, 35ATube, TainS41, TC2, UT50
   tensionEnd: false,         // 37  Hacoba, TainS41
   tensionPostSet: false,     // 38  Hacoba, TainS41
   tensionStart: false,       // 39  Hacoba, TainS41
   threadBreakTimeout: false, // 40  Hacoba
   threadGuide: false,        // 41  Hacoba
   timeConveyor: false,       // 42  Hacoba
   timeDeposit: false,        // 43  Hacoba
   underwindD: false,         // 44  Hacoba, TainS41
   underwindL: false,         // 45  Hacoba
   underwindS: false,         // 46  Hacoba
   yards: false,              // 47  861FC, 861Wax, Hacoba, TainS41
   length: false,             // 48  HeliPirn
   girth: false,              // 49  HeliPirn
   bottomTrim: false,         // 50  HeliPirn
   cycleVariable: false,      // 51  HeliPirn
   f1: false,                 // 52  HeliPirn
   startPos: false,           // 53  HeliPirn
   traverseMax: false,        // 54  HeliPirn
   traverseMin: false,        // 55  HeliPirn
   traverseSpeed: false,      // 56  HeliPirn
   trimAmount: false,         // 57  HeliPirn
   type: false,               // 58  HeliPirn
   acceleration: false,       // 59  KV2019B, HeliTwist
   ballSpindle: false,        // 60  KV2019B, HeliTwist
   ballTop: false,            // 61  KV2019B, HeliTwist
   clockSet: false,           // 62  KV2019B, HeliTwist, M50, M50Wax, Ratera, Saco, Sahm, Tain35AFP, Tain35AR, 35ATube, TC2, TexKing, UT50
   counterSet: false,         // 63  KV2019B, HeliTwist
   counterSwitch: false,      // 64  KV2019B, HeliTwist
   deceleration: false,       // 65  KV2019B, HeliTwist
   deckLower: false,          // 66  KV2019B, HeliTwist
   deckUpper: false,          // 67  KV2019B, HeliTwist
   delayLower: false,         // 68  KV2019B, HeliTwist
   delayUpper: false,         // 69  KV2019B, HeliTwist
   encoderImpulse: false,     // 70  KV2019B, HeliTwist
   fAnti: false,              // 71  KV2019B, HeliTwist
   faultWarning: false,       // 72  KV2019B, HeliTwist
   firstTwist: false,         // 73  KV2019B, HeliTwist
   fMinLower: false,          // 74  KV2019B, HeliTwist
   hAnti: false,              // 75  KV2019B, HeliTwist
   maxStroke: false,          // 76  KV2019B, HeliTwist
   maxStrokeCount: false,     // 77  KV2019B, HeliTwist
   maxStrokeCycle: false,     // 78  KV2019B, HeliTwist
   minStroke: false,          // 79  KV2019B, HeliTwist
   packageType: false,        // 80  KV2019B, HeliTwist
   pulseRate: false,          // 81  KV2019B, HeliTwist
   ringSpeedUp: false,        // 82  KV2019B, HeliTwist
   ringStartPos: false,       // 83  KV2019B, HeliTwist
   ringSpeedDown: false,      // 84  KV2019B, HeliTwist
   rollerCoefficient: false,  // 85  KV2019B, HeliTwist
   rollerDiameter: false,     // 86  KV2019B, HeliTwist
   rollerImuplse: false,      // 87  KV2019B, HeliTwist
   rotation: false,           // 88  KV2019B, HeliTwist
   runReset: false,           // 89  KV2019B, HeliTwist
   screwPitch: false,         // 90  KV2019B, HeliTwist
   secondTwist: false,        // 91  KV2019B, HeliTwist
   speedLower: false,         // 92  KV2019B, HeliTwist
   speedMonitoring: false,    // 93  KV2019B, HeliTwist
   speedUpper: false,         // 94  KV2019B, HeliTwist
   strokeIncrement: false,    // 95  KV2019B, HeliTwist
   traveler1: false,          // 96  KV2019B, HeliTwist, Saco
   traveler2: false,          // 97  KV2019B, HeliTwist, Saco
   traveler3: false,          // 98  KV2019B, HeliTwist, Saco
   traveler4: false,          // 99  KV2019B, HeliTwist, Saco
   traveler5: false,          // 100 KV2019B, HeliTwist
   traveler6: false,          // 101 KV2019B, HeliTwist
   traveler7: false,          // 102 KV2019B, HeliTwist
   traveler8: false,          // 103 KV2019B, HeliTwist
   traveler9: false,          // 104 KV2019B, HeliTwist
   travelerQty1: false,       // 105 KV2019B, HeliTwist, Saco
   travelerQty2: false,       // 106 KV2019B, HeliTwist, Saco
   travelerQty3: false,       // 107 KV2019B, HeliTwist, Saco
   travelerQty4: false,       // 108 KV2019B, HeliTwist, Saco
   travelerQty5: false,       // 109 KV2019B, HeliTwist
   travelerQty6: false,       // 110 KV2019B, HeliTwist
   travelerQty7: false,       // 111 KV2019B, HeliTwist
   travelerQty8: false,       // 112 KV2019B, HeliTwist
   travelerQty9: false,       // 113 KV2019B, HeliTwist
   yarnSpeedMin: false,       // 114 861FC
   yarnSpeedMax: false,       // 115 861FC
   graf: false,               // 116 861FC, Duro, Kingspool, TexKing
   gearC: false,              // 117 861FC, 861Tack, 861Wax, Sahm
   gearD: false,              // 118 861FC, 861Tack, 861Wax, Sahm
   gearE: false,              // 119 861FC, 861Tack, 861Wax, Sahm
   gearF: false,              // 120 861FC, 861Tack, 861Wax, Sahm
   diffCamLink: false,        // 121 861Tack
   tensionAdj: false,         // 122 861Tack
   yarnSpeed: false,          // 123 861Tack
   counterFC71: false,        // 124 861Wax
   counterFC72: false,        // 125 861Wax
   waxTemp: false,            // 126 861Wax
   wiperWeights: false,       // 127 861Wax
   backPressMax: false,       // 128 M50, M50Wax, Sahm
   backPressMin: false,       // 129 M50, M50Wax, Sahm
   scaleFactor: false,        // 130 M50Wax
   gearSpindle: false,        // 131 M50
   gearIntermediate: false,   // 132 M50
   gearInnerGainer: false,    // 133 M50
   gearOuterGainer: false,    // 134 M50
   gearCam: false,            // 135 M50
   bondTemp: false,           // 136 Mahan
   boxPressure: false,        // 137 Mahan
   boxSetting: false,         // 138 Mahan
   boxStretch: false,         // 139 Mahan
   creelType: false,          // 140 Mahan
   numberPasses: false,       // 141 Mahan
   oven1PanelBtm: false,      // 142 Mahan
   oven1PanelTop: false,      // 143 Mahan
   oven1TempBtm: false,       // 144 Mahan
   oven1TempTop: false,       // 145 Mahan
   oven2PanelBtm: false,      // 146 Mahan
   oven2PanelTop: false,      // 147 Mahan
   oven2TempBtm: false,       // 148 Mahan
   oven2TempTop: false,       // 149 Mahan
   preFeedPressure: false,    // 150 Mahan, Sahm
   preFeedSetting: false,     // 151 Mahan
   speedFast: false,          // 152 Mahan
   speedSlow: false,          // 153 Mahan
   zoneBBarPos: false,        // 154 Mahan
   zoneBTensionMax: false,    // 155 Mahan
   zoneBTensionMin: false,    // 156 Mahan
   zoneCTensionMax: false,    // 157 Mahan
   zoneCTensionMin: false,    // 158 Mahan
   wiperWeight: false,        // 159 Mahan
   linearSet: false,          // 160 Ratera
   changeGear: false,         // 161 Saco
   drivenConstant: false,     // 162 Saco
   driverConstant: false,     // 163 Saco
   backPressureBegin: false,  // 164 DP5, Duro, Kingspool, Xeno
   backPressureEnd: false,    // 165 DP5, Duro, Kingspool, Xeno
   degreesEnd: false,         // 166 DP5, Duro, Kingspool, Xeno
   degreesStart: false,       // 167 DP5, Duro, Kingspool, Xeno
   leftCompensation: false,   // 168 DP5, Duro, Xeno
   leftTaper: false,          // 169 DP5, Duro, Xeno
   programName: false,        // 170 DP5, Duro, Xeno
   rightCompensation: false,  // 171 DP5, Duro, Xeno
   rightTaper: false,         // 172 DP5, Duro, Xeno
   speedEnd: false,           // 173 DP5, Duro
   speedMiddle: false,        // 174 DP5, Duro
   speedStart: false,         // 175 DP5, Duro
   traverse: false,           // 176 DP5, Duro, Kingspool, Xeno
   tubeOD: false,             // 177 DP5, Duro, Xeno
   windRatioStart: false,     // 178 DP5, DS10E, Duro, Kingspool, Xeno, 861FC/Tack/Wax
   windRatioEnd: false,       // 179 DP5, DS10E, Duro, Kingspool, Xeno, 861FC/Tack/Wax
   windType: false,           // 180 DP5, Duro, Kingspool, Xeno
   yardsPerPkg: false,        // 181 DP5, Duro, Xeno
   metersPerPkg: false,       // 182 Kingspool
   decelSpeed: false,         // 183 Xeno
   initialSpeed: false,       // 184 Xeno
   productionSpeed: false,    // 185 Xeno
   deliverySpeed: false,      // 186 Sahm
   balloonGuide: false,       // 187 TC2, UT50
   numEnds: false,            // 188 TC2, UT50
   potLids: false,            // 189 TC2, UT50
   spindleWraps: false,       // 190 TC2, UT50
   supplyTubeColor: false,    // 191 TC2, UT50
   tensionDevice: false,      // 192 TC2, UT50
   tensionSet: false,         // 193 TC2, UT50
   bullet: false,             // 194 TC2
   tensionLI: false,          // 195 Tain35AFP, Tain35AR 35ATube
   tensionLow: false,         // 196 Tain35AFP, Tain35AR 35ATube
   tensionMid: false,         // 197 Tain35AFP, Tain35AR 35ATube
   tensionHigh: false,        // 198 Tain35AFP, Tain35AR 35ATube
   specification: false,      // 199 Tain35AFP, Tain35AR 35ATube
   spacing: false,            // 200 Tain35AFP, Tain35AR, 35ATube
   underwindB: false,         // 201 TainS41
   underwindD_DNU: false,     // 202 TainS41 (duplicate of 44, do not use)
   underwindK: false,         // 203 TainS41
   underwindT: false,         // 204 TainS41
   reserveDisk: false,        // 205 UT50
   springNum: false,          // 206 UT50
   celsius1: false,           // 207 Xorella
   celsius2: false,           // 208 Xorella
   celsius3: false,           // 209 Xorella
   celsiusMin1: false,        // 210 Xorella
   celsiusMin2: false,        // 211 Xorella
   celsiusMin3: false,        // 212 Xorella
   cycleCount: false,         // 213 Xorella
   mBar1: false,              // 214 Xorella
   mBar2: false,              // 215 Xorella
   mBar3: false,              // 216 Xorella
   minTime1: false,           // 217 Xorella
   minTime2: false,           // 218 Xorella
   minTime3: false,           // 219 Xorella
   pounds: false,             // 220 Xorella, Mahan Dryer
   burner: false,             // 221 Mahan Dryer
   circulationSpeed: false,   // 222 Mahan Dryer
   exhaust: false,            // 223 Mahan Dryer
   fan: false,                // 224 Mahan Dryer
   highLimit: false,          // 225 Mahan Dryer
   tempControl: false,        // 226 Mahan Dryer
   timer: false,              // 227 Mahan Dryer
   recipe: false,             // 228 Mahan Oven
   dancerArmTension: false,   // 229 Mahan Oven
   totalEnds: false,          // 230 Gilbos Doubler
};

const Machine861FCValidations = [1, 6, 7, 9, 10, 11, 12, 47, 114, 115, 116, 117, 118, 119, 120, 178, 179];
const Machine861TackValidations = [1, 6, 7, 8, 9, 10, 11, 12, 13, 24, 25, 117, 118, 119, 120, 121, 122, 123, 178, 179];
const Machine861WaxValidations = [1, 6, 7, 9, 10, 47, 117, 118, 119, 120, 124, 125, 126, 127, 178, 179];
const MachineDoublerValidations = [0, 1, 6, 7, 13, 24, 25, 26, 27, 28, 230];
const MachineDP5Validations = [1, 6, 7, 27, 28, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175,
   176, 177, 178, 179, 180, 181];
const MachineDS10EValidations = [0, 1, 2, 3, 4, 5, 6, 7, 178, 179];
const MachineDS21Validations = [1, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
const MachineDuroValidations = [1, 6, 7, 27, 28, 116, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175,
   176, 177, 178, 179, 180, 181];
const MachineHacobaValidations = [1, 6, 7, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47];
const MachineHeliKV2019BValidations = [1, 6, 7, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75,
   76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102,
   103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113];
const MachineHeliPirnValidations = [1, 3, 4, 6, 7, 26, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58];
const MachineHeliTwisterValidations = [1, 6, 7, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71,
   72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94,
   95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113];
const MachineKingspoolValidations = [0, 1, 6, 7, 116, 164, 165, 166, 167, 176, 178, 179, 180, 182];
const MachineM50Validations = [1, 6, 7, 27, 28, 62, 128, 129, 131, 132, 133, 134, 135];
const MachineM50WaxValidations = [1, 6, 7, 27, 28, 62, 128, 129, 130];
const MachineMahanDryerValidations = [1, 6, 7, 220, 221, 222, 223, 224, 225, 226, 227];
const MachineMahanOvenValidations = [1, 6, 7, 13, 24, 25, 136, 137, 138, 139, 140, 141, 142, 143,
   144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 228, 229];
const MachineRateraValidations = [1, 6, 7, 24, 25, 27, 28, 62, 160];
const MachineSacoValidations = [1, 6, 7, 36, 62, 96, 97, 98, 99, 105, 106, 107, 108, 161, 162, 163];
const MachineSahmValidations = [1, 6, 7, 8, 24, 25, 27, 28, 62, 117, 118, 119, 120, 128, 129, 150, 186];
const MachineSaurerTC2Validations = [0, 1, 5, 6, 7, 36, 62, 187, 188, 189, 190, 191, 192, 193, 194];
const MachineTaining35AFPValidations = [0, 1, 6, 7, 36, 62, 195, 196, 197, 198, 199, 200];
const MachineTaining35ARValidations = [0, 1, 6, 7, 36, 62, 195, 196, 197, 198, 199, 200];
const MachineTaining35ATubeValidations = [0, 1, 6, 7, 36, 62, 195, 196, 197, 198, 199, 200];
const MachineTainingS41Validations = [1, 6, 7, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 44, 47, 201, 203, 204];
const MachineTexKingspoolValidations = [1, 3, 4, 6, 7, 62, 116];
const MachineUT50Validations = [0, 1, 5, 6, 7, 36, 62, 187, 188, 189, 190, 191, 192, 193, 205, 206];
const MachineXenoValidations = [1, 5, 6, 7, 27, 28, 164, 165, 166, 167, 168, 169, 170, 171, 172,
   176, 177, 178, 179, 180, 181, 183, 184, 185];
const MachineXorellaValidations = [0, 1, 6, 7, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220];

// these values are the machine type ids
const LookUpValidations = {
   2: MachineDS21Validations,
   32: MachineDS10EValidations,
   7: MachineDoublerValidations,
   20: MachineHacobaValidations,
   29: MachineHeliPirnValidations,
   30: MachineHeliTwisterValidations,
   35: MachineHeliKV2019BValidations,
   1: Machine861FCValidations,
   5: Machine861TackValidations,
   6: Machine861WaxValidations,
   16: MachineM50WaxValidations,
   3: MachineM50Validations,
   27: MachineMahanOvenValidations,
   19: MachineRateraValidations,
   14: MachineSacoValidations,
   21: MachineDP5Validations,
   38: MachineDuroValidations,
   31: MachineKingspoolValidations,
   36: MachineXenoValidations,
   13: MachineSahmValidations,
   10: MachineSaurerTC2Validations,
   22: MachineTaining35ATubeValidations,
   11: MachineTaining35AFPValidations,
   12: MachineTaining35ARValidations,
   28: MachineTainingS41Validations,
   9: MachineTexKingspoolValidations,
   15: MachineUT50Validations,
   37: MachineXorellaValidations,
   39: MachineMahanDryerValidations
};

const DefaultMachineSetup = {
   setupId: null,
   setupDate: null,
   itemNumbner: "",
   machineType: 4, //Other (A placeholder setup used until user can chose a machine type definition)
   isActive: true, //Any new setup should default to being active
   instructions: "", //Any new setup should default to empty string
   orderToProcess: 0, //Only cumulative setups need this, and the default setup is unknown except when it is a sole setup
   calcType: "",
};

const MachineConstants = {
   AllErrors,
   DefaultErrors,
   LookUpValidations,
   DefaultMachineSetup
};

export default MachineConstants;
